import { Outlet } from 'react-router-dom'

import { Box, Button, SearchField } from '@factorialco/deprecated-design-system'
import { WorkSchedulesContainerDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import PaginatedSchedulesList from './PaginatedSchedulesList'

interface Props {
  contractVersions: ContractVersions
}

const WorkSchedulesContainer = ({ contractVersions }: Props) => {
  const { navigation } = useNavigation()
  const { debouncedSearch, search, onSearch } = useDebouncedSearch()
  const { nodes, loading, controls } = usePaginatedQuery(WorkSchedulesContainerDocument, {
    extractConnection: (data) => data?.workSchedule.schedulesConnection,
    variables: { onlyActive: true, searchByName: debouncedSearch },
  })
  const schedules = nodes || []

  return (
    <ResponsivePage.Body showHeader={false}>
      <Box gap="s16" alignItems="flexEnd">
        <Box gap="s8" justifyContent="flexEnd" flexDirection="row" width="fit-content">
          <SearchField
            placeholder={i18n.t('shift_management.rotating_shifts.search_by_name')}
            onSearch={onSearch}
            search={search}
            variant="regular"
          />
          <Button.Router
            type="secondary"
            to={navigation.settings.workSchedule.new.fullPath()}
            iconName="add"
          >
            {i18n.t('settings.work_schedule.add')}
          </Button.Router>
        </Box>

        {!loading && (
          <PaginatedSchedulesList
            schedules={schedules}
            controls={controls}
            contractVersions={contractVersions}
          />
        )}
      </Box>
      {/* All the action modals for WS are rendered on sub-routes, thus we need this Outlet here. */}
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default observer(WorkSchedulesContainer)
